module.exports = __webpack_public_path__ + "img/icon-lock-yellow-quest-dark.335ce536.svg";